// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".content-block[data-v-19c8e50f]{font-size:.875rem!important;font-weight:400!important;letter-spacing:.25px!important;line-height:1.571!important}@media (min-width:600px){.content-block[data-v-19c8e50f]{font-size:1rem!important;font-weight:400!important;letter-spacing:.15px!important;line-height:1.5!important}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
